import { GameApp } from "./app/GameApp";

new GameApp();
